import { call, put, takeEvery } from "redux-saga/effects";
import {
  ADD_PHYSICAL_ART,
  GET_PHYSICAL_ART_BY_USER_ID,
  GET_PHYSICAL_ART_BY_SELL_ITEM_ID,
  GET_PHYSICAL_ART_BY_ID,
  ADD_PHYSICAL_SELLITEM,
  GET_EXPLORE_PHYSICAL_ART,
  LIKE_VIEW_PHYSICAL,
  P_GET_CANVAS_PAPER_SIZE,
} from "./actionTypes";
import {
  addPhysicalArtFail,
  addPhysicalArtSuccess,
  getPhysicalArtByUserIdFail,
  getPhysicalArtByUserIdSuccess,
  getPhysicalArtBySellItemIdFail,
  getPhysicalArtBySellItemIdSuccess,
  getPhysicalArtByIdFail,
  getPhysicalArtByIdSuccess,
  addPhysicalSellItemSuccess,
  addPhysicalSellItemFail,
  getExplorePhysicalArtSuccess,
  getExplorePhysicalArtFail,
  likeViewPhysicalFail,
  likeViewPhysicalSuccess,
  PhysicalgetCanvasPaperSizeSuccess,
  PhysicalgetCanvasPaperSizeFail,
} from "./actions";
import {
  addPhysicalArtApi,
  getPhysicalArtByUserIdApi,
  getPhysicalArtBySellItemIdApi,
  getPhysicalArtByIdApi,
  addPhysicalSellItemApi,
  likeviewPhysicalApi,
  getExplorePhysicalArtApi,
  getCanvasPaperSizeApi,
} from "helpers/backend_helper";

// ========================= PHYSICAL ART METADATA =========================

function* addPhysicalArt({ payload: { data, callback } }) {
  try {
    const response = yield call(addPhysicalArtApi, data);

    if (response.status === "failure") {
      return yield put(addPhysicalArtFail(response.message));
    }

    callback && callback(response);
    yield put(addPhysicalArtSuccess(response.data));
  } catch (error) {
    yield put(addPhysicalArtFail(error));
  }
}

function* getPhysicalArtByUserId({ payload: { id, callback } }) {
  try {
    const response = yield call(getPhysicalArtByUserIdApi, id);

    if (response.status === "failure") {
      return yield put(getPhysicalArtByUserIdFail(response.message));
    }

    callback && callback(response);
    yield put(getPhysicalArtByUserIdSuccess(response.data));
  } catch (error) {
    yield put(getPhysicalArtByUserIdFail(error));
  }
}

function* getPhysicalArtBySellItemId({ payload: { sell_item_id, callback } }) {
  try {
    const response = yield call(getPhysicalArtBySellItemIdApi, sell_item_id);

    if (response.status === "failure") {
      return yield put(getPhysicalArtBySellItemIdFail(response.message));
    }

    callback && callback(response);
    yield put(getPhysicalArtBySellItemIdSuccess(response.data));
  } catch (error) {
    yield put(getPhysicalArtBySellItemIdFail(error));
  }
}

function* getPhysicalArtById({ payload: { id, callback } }) {
  try {
    console.log("🚀 SAGA: Fetching physical art for ID:", id);
    const response = yield call(getPhysicalArtByIdApi, id);
    console.log("📡 SAGA: API Response:", response);

    if (response.status === "failure") {
      console.log("❌ SAGA: API returned failure");
      yield put(getPhysicalArtByIdFail(response.message));
      return;
    }

    console.log("🟡 SAGA: Dispatching SUCCESS with data:", response.data);

    // Make sure we're passing the data correctly
    yield put(getPhysicalArtByIdSuccess(response.data));

    if (callback) {
      console.log("🟡 SAGA: Executing callback");
      callback(response.data);
    }
  } catch (error) {
    console.error("❌ SAGA Error:", error);
    yield put(getPhysicalArtByIdFail(error.message || error));
  }
}

// ========================= PHYSICAL ART SELL ITEMS =========================

function* addPhysicalSellItem({ payload: { data, callback } }) {
  try {
    const response = yield call(addPhysicalSellItemApi, data);

    if (response.status === "failure") {
      yield put(addPhysicalSellItemFail(response.message));
      return;
    }

    if (callback) callback(response);
    yield put(addPhysicalSellItemSuccess(response.data));
  } catch (error) {
    yield put(addPhysicalSellItemFail(error.message || error));
  }
}

function* likeViewPhysicalOwner({ payload: { data, callback } }) {
  try {
    const response = yield call(likeviewPhysicalApi, data);
    if (response.status === "failure") {
      return yield put(likeViewPhysicalFail(response.message));
    }

    callback && callback(response);
    yield put(likeViewPhysicalSuccess(response.data));
  } catch (error) {
    console.log("error", error);
    yield put(likeViewPhysicalFail(error));
  }
}

function* getExplorePhysicalArt({ payload }) {
  try {
    const response = yield call(getExplorePhysicalArtApi, payload);

    if (response.status === "failure") {
      yield put(getExplorePhysicalArtFail(response.message));
      return;
    }

    yield put(
      getExplorePhysicalArtSuccess(response.data?.data || response.data)
    );
  } catch (error) {
    console.error("Error fetching physical art:", error);
    yield put(getExplorePhysicalArtFail(error.message || error));
  }
}


function* P_getCanvasPaperSize({ payload: { data, callback } }) {
  try {
    console.log("ccalled");
    const response = yield call(getCanvasPaperSizeApi, data);
    console.log("physical data size",response);
    if (response.status === "failure") {
      return yield put(PhysicalgetCanvasPaperSizeFail(response.message));
    }
    yield put(PhysicalgetCanvasPaperSizeSuccess(response.data));
    callback && callback(response);
  } catch (error) {
    yield put(PhysicalgetCanvasPaperSizeFail(error));
  }
}
// ========================= WATCHER SAGA =========================

function* PhysicalArtSaga() {
  yield takeEvery(ADD_PHYSICAL_ART, addPhysicalArt);
  yield takeEvery(GET_PHYSICAL_ART_BY_USER_ID, getPhysicalArtByUserId);
  yield takeEvery(GET_PHYSICAL_ART_BY_SELL_ITEM_ID, getPhysicalArtBySellItemId);
  yield takeEvery(GET_PHYSICAL_ART_BY_ID, getPhysicalArtById);
  yield takeEvery(LIKE_VIEW_PHYSICAL, likeViewPhysicalOwner);
  yield takeEvery(ADD_PHYSICAL_SELLITEM, addPhysicalSellItem);
  yield takeEvery(GET_EXPLORE_PHYSICAL_ART, getExplorePhysicalArt);
  yield takeEvery(P_GET_CANVAS_PAPER_SIZE, P_getCanvasPaperSize);
}

export default PhysicalArtSaga;
